import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sharedcustomerinfoonly',
  templateUrl: './sharedcustomerinfoonly.component.html',
  styleUrls: ['./sharedcustomerinfoonly.component.css']
})
export class SharedcustomerinfoonlyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
